@if (decisionError) {
  <app-rerun-task message="rerunTask.orUpload" (rerun)="createDecision()"></app-rerun-task>
}

<section class="selected-products">
  <h4>{{ 'makeDecision.selectedProducts' | translate }}</h4>
  @if (listedProducts.length) {
    <ul>
      @for (product of listedProducts; track product) {
        <li>
          <mat-checkbox
            [checked]="isSelected(product)"
            (change)="updateSelection($event.checked, product)"
          >
            {{ product.product }} ({{ product.organisation }})
          </mat-checkbox>
        </li>
      }
    </ul>
  } @else {
    <p>{{ 'makeDecision.noProductsSelected' | translate }}</p>
  }
</section>

<div class="document-upload">
  @if (templatesError) {
    <app-inline-snackbar
      [type]="SnackbarType.ERROR"
      [message]="'transcriber.templatesError' | translate"
      [showCloseButton]="false"
    ></app-inline-snackbar>
  }

  <mat-form-field appearance="outline">
    <mat-label>{{ 'transcriber.selectDecisionTemplate' | translate }}</mat-label>
    <mat-select
      name="templateType"
      #templateTypeSelect="ngModel"
      required
      [(ngModel)]="selectedTemplateType"
      [compareWith]="compareTemplateTypes"
      (selectionChange)="onTemplateTypeChange()"
    >
      @for (templateType of templateTypes; track templateType.task) {
        <mat-option [value]="templateType">
          {{ templateType.label }}
        </mat-option>
      }
    </mat-select>

    @if (templateTypeSelect.invalid && templateTypeSelect.touched) {
      <mat-error>
        {{ 'transcriber.selectDecisionTemplateRequired' | translate }}
      </mat-error>
    }
  </mat-form-field>

  <app-upload-document
    [optionalFilesTitle]="'upload.optionalManyFiles'"
    [documentType]="DocumentTypeEnum.ACTION_PLAN"
  ></app-upload-document>
  <div class="options">
    <button
      mat-flat-button
      [disabled]="isCreateDecisionDisabled"
      [class.disabled]="isCreateDecisionDisabled"
      (click)="createDecision()"
    >
      {{ 'stepper.createDecision' | translate }}
    </button>
  </div>
</div>

@if (isCreatingDecision) {
  <div class="empty-decision">
    <app-waiting [message]="'stepper.creatingDecision' | translate"></app-waiting>
    <button mat-stroked-button class="preview-button" (click)="previewDecision()">
      {{ 'documentEditor.preview' | translate }}
    </button>
  </div>
} @else if (decisionFile) {
  <div class="document-upload">
    <app-upload-document
      [allowOptionalFiles]="false"
      [documentType]="DocumentTypeEnum.DECISION"
    ></app-upload-document>
  </div>

  <p>{{ 'transcriber.decisionCheckDescription' | translate }}</p>
  <button mat-stroked-button class="preview-button" (click)="previewDecision()">
    {{ 'documentEditor.preview' | translate }}
  </button>
}
